import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import React from "react";
import { DropTarget } from "react-drag-drop-container";
import { FormattedMessage } from "react-intl";
import "./style.css";

const dropTargetFunction = (
  text, record, index, draggingFrom, setDroppingOn
) => {
  return <DropTarget
    onDragEnter={() => { if (record.conto.rowId !== draggingFrom) { setDroppingOn(record.conto.rowId); } }}
    onDragLeave={() => { setDroppingOn(null); }}
    targetKey="precog-intrastat-articles-drag" highlightClassName="precog-conto-intrastat-drag-highlight" >{text || <div className="conti-intrastat-empty-cell">&nbsp;</div>}</DropTarget>;
};

export const columnsIntrastat = (draggingFrom, setDroppingOn) => {
  return [
    {
      title:
        <div className="intrastat-column-title">Nomenclatura
          <Tooltip placement="bottom" title={<FormattedMessage id="preCog.intrastatTab.tooltips.combinedNomenclature"/>} color={"#005075"}>
            <FontAwesomeIcon icon={["fas", "info-circle"]} />
          </Tooltip>
        </div>,
      width: "35%",
      dataIndex: "name",
      key: "name",
      render: (
        text, record, index
      ) => dropTargetFunction(
        text, record, index, draggingFrom, setDroppingOn
      )
    },
    {
      title:
        <div className="intrastat-column-title">Importo
          <Tooltip placement="bottom" title={<FormattedMessage id="preCog.intrastatTab.tooltips.amount" />} color={"#005075"}>
            <FontAwesomeIcon icon={["fas", "info-circle"]} />
          </Tooltip>
        </div>,
      align: "left",
      headerAlign: "left",
      width: "15%",
      dataIndex: "total",
      key: "total",
      render: (
        text, record, index
      ) => dropTargetFunction(
        text, record, index, draggingFrom, setDroppingOn
      )
    },
    {
      title: <div className="intrastat-column-title">Data registrazione intra <FontAwesomeIcon icon={["fas", "info-circle"]} /></div>,
      width: "24%",
      dataIndex: "postingDate",
      key: "postingDate",
      render: (
        text, record, index
      ) => dropTargetFunction(
        text, record, index, draggingFrom, setDroppingOn
      )
    },
    {
      title: <div className="intrastat-column-title">Rettifica <FontAwesomeIcon icon={["fas", "info-circle"]} /></div>,
      width: "4%",
      dataIndex: "rectificationDate",
      key: "rectificationDate",
      render: (
        text, record, index
      ) => dropTargetFunction(
        text, record, index, draggingFrom, setDroppingOn
      )
    },
    {
      title: "",
      width: "22%",
      dataIndex: "removeConto",
      key: "removeConto",
      render: (
        text, record, index
      ) => dropTargetFunction(
        text, record, index, draggingFrom, setDroppingOn
      )
    }
  ];

};
